
let deploymentConfiguration = require("./default.json");

export default deploymentConfiguration;
